import * as krakenModels from '@/model/config/krakenModels';

export const launchLogin = async () => {
  krakenModels.loginOpen();
  return null;
};
